import { render, staticRenderFns } from "./TenantConfig.vue?vue&type=template&id=0656c506&scoped=true&"
import script from "./TenantConfig.vue?vue&type=script&lang=js&"
export * from "./TenantConfig.vue?vue&type=script&lang=js&"
import style0 from "./TenantConfig.vue?vue&type=style&index=0&id=0656c506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0656c506",
  null
  
)

export default component.exports